<template>
  <div class="card p-5">
      <Calendar 
        id="calendarAbsenceId" 
        :headerToolbar="false" 
        :event="events" 
        :key="events.length" 
      />
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch, defineProps } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Calendar from "@/components/CalendarSimple.vue";

const route = useRoute();
const store = useStore();

const props = defineProps({
    dates: {
      type: Object,
      required: true
    },
    office: {
      type: String,
      required: true
    }
});

const absencesData = ref([]);
const events = ref([]);

watch(() => [props.dates.start_date, props.dates.end_date, props.office], () => {
  manageCalendar();
}, { deep: true });

async function manageCalendar() {
  let data = {
    start_date: props.dates?.start_date,
    end_date: props.dates?.end_date,
    office: props.office
  };

  try {
    const res = await store.dispatch('absences/loadManageAbsences', data);    
    absencesData.value = res.data.holidays || [];
    updateEvents();
  } catch (error) {
   
  }
}

function updateEvents() {
  events.value = absencesData.value.map(item => ({
    title: item?.holiday_type ? `${item?.title} (${item?.holiday_type?.name})` : `${item?.title} (${item?.country?.name})`,
    start: item?.start_date,
    end: item?.end_date,
    extendedProps: {
      id: item?.id || null,
      startTime: item?.start_date || null,
      endTime: item?.end_date || null,
      color: item?.color || "#000000"
    }
  }));
  
  nextTick(() => {
    document.getElementById("calendarAbsenceId")?.dispatchEvent(new Event("refresh"));
  });
}

onMounted(() => {
  if (route.query.viewType === 'calendar') {
    manageCalendar();
  }
});
</script>
